<template>
  <div id="app">
    <RoiAssessment></RoiAssessment>
  </div>
</template>

<script>
import RoiAssessment from './components/RoiAssessment.vue'

export default {
  name: 'App',
  components: {
    RoiAssessment
  }
}
</script>

